/* Rose de Lille — Update the monetary savings badge when the selected product variant changes. */
(function () {
  'use strict';

  function formatSaving(cents, currency) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !event.target.querySelectorAll) return;
    var badges = event.target.querySelectorAll('[data-rdl-saving-badge]');
    if (!badges.length) return;
    var original = Number(variant.compare_at_price || 0);
    var current = Number(variant.price || 0);
    var difference = original - current;

    badges.forEach(function (badge) {
      badge.hidden = !(original > current && difference > 0);
      if (badge.hidden) return;
      var value = badge.querySelector('[data-rdl-saving-amount]');
      if (value) value.textContent = 'Économisez ' + formatSaving(difference, badge.getAttribute('data-currency'));
    });
  });
})();

/* Reveal the existing six-product featured collection from left to right, once in viewport. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rdl-pdp-products-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin:'0px 0px -8% 0px', threshold:.06 });
  function register(root) {
    var items=[];
    if (root.matches && root.matches('.template-product #MainContent .index-products')) items.push(root);
    if (root.querySelectorAll) items=items.concat(Array.prototype.slice.call(root.querySelectorAll('.template-product #MainContent .index-products')));
    items.forEach(function (node) {
      if (node.classList.contains('rdl-pdp-products-pending')) return;
      node.classList.add('rdl-pdp-products-pending');
      observer.observe(node);
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){register(document);},{once:true});
  else register(document);
  document.addEventListener('shopify:section:load',function(event){register(event.target);});
})();
